import { render } from "./AcTextarea.vue?vue&type=template&id=2a7dedc4&ts=true"
import script from "./AcTextarea.vue?vue&type=script&lang=ts"
export * from "./AcTextarea.vue?vue&type=script&lang=ts"

import "./AcTextarea.vue?vue&type=style&index=0&id=2a7dedc4&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__